// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".houseingRes[data-v-22d6a908] .avue-crud__menu{display:none}.cell-color[data-v-22d6a908]{color:#409eff!important;cursor:pointer}[data-v-22d6a908] .el-table th.is-leaf{padding-left:15px;padding-right:15px}", ""]);
// Exports
module.exports = exports;
